/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Roster from '@/components/Roster'
import Teams from '@/components/Teams'
import Results from '@/components/Results'
import General from '@/components/General'
import Admin from '@/components/Admin'


import VueRouter from 'vue-router'
import firebase from 'firebase'

Vue.use(Router)

let router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        {
            path: "/",
            name: "Login",
            component: Login,
            meta: {
                requiresUnauth: true
            }
        },
        {
            path: "/home/",
            name: "Home",
            component: Home,
            children: [
                {
                    path: "general",
                    name: "General",
                    component: General,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "roster",
                    name: "Roster",
                    component: Roster,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "teams",
                    name: "Teams",
                    component: Teams,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "results",
                    name: "Results",
                    component: Results,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: "admin",
                    name: "Admin",
                    component: Admin,
                    meta: {
                        requiresAuth: true
                    }
                },
                {
                    path: 'forum',
                    name: "Forum",
                    beforeEnter() {
                        location.href = 'http://frwd.ru/frwdforum/index.php'
                    },
                    meta: {
                        requiresAuth: true
                    }
                }
            ],
            meta: {
                requiresAuth: true
            }
        }

    ]
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    next()
                } else {
                    next({
                        path: '/'
                    })
                }
            }
        )
    } else if (to.matched.some(record => record.meta.requiresUnauth)) {
        firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    next({
                        path: '/home/general'
                    })
                } else {
                    next()
                }
            }
        )
    } else {
        next();
    }
});

export default router
